import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
import { Tooltip as Tooltip2 } from "@mui/material";
export default function BarChartBreakdown() {
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const [opacity, setOpacity] = useState({ Open: 1, Answered: 1, Accepted: 1 });
	const [loading, setLoading] = React.useState(false);
	const [toolTipValue, setTooltipValue] = React.useState('')

	const handleMouseEnter = (o) => {
		const { dataKey } = o;
			setOpacity((prevOpacity) => ({
			...prevOpacity,
			[dataKey]: 0.5,
		}));
	};

	const handleMouseLeave = (o) => {
		const { dataKey } = o;
		setOpacity((prevOpacity) => ({
			...prevOpacity,
			[dataKey]: 1,
		}));
	};

	useEffect(() => {
		if (expertOverview.questionCountBreakdown.length > 0) {
			setLoading(false)
		}
	}, [])

	const valueFormatter = (value) => {
		if (value.length > 5) {
			setTooltipValue(value)
			return `${value.substring(0, 5)}...`
		}
		else {
			return value
		}
	}
	return (
		<>
			<Spin spinning={loading}>
				<ResponsiveContainer width="100%" minHeight={400}>
					<BarChart
						width={500}
						height={300}
						data={expertOverview.questionCountBreakdown}
						margin={{
							top: 20,
							right: 30,
							left: 20,
							bottom: 5,
						}}
						barSize={30}
					>
						<CartesianGrid stroke="#ececec" strokeWidth={1} vertical={false} />
						<XAxis dx={7} tickFormatter={(value)=>valueFormatter(value)} interval={0} angle={-45} dataKey="name" fontSize={12} onMouseEnter={(params)=>setTooltipValue(params)} onMouseLeave={()=>setTooltipValue('')}>
							<Label position={"inside"} dy={20}>Domains</Label>
						</XAxis>
						<YAxis fontSize={12} axisLine={false} tickLine={false} allowDecimals={false}>
							<Label dx={-18} position="inside" angle={-90}>Questions Volume</Label>
						</YAxis>
						<Tooltip wrapperStyle={{ fontWeight: 'bold', fontSize: '12px',padding:'12px'}} cursor={{fill:'transparent'}} />
						<Legend onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} wrapperStyle={{ fontSize: '12px', bottom: '4px',padding:'12px' }} margin={4} />
						<Bar strokeOpacity={opacity.Open} dataKey="Open" stackId="a" fill="#3086B9" />
						<Bar strokeOpacity={opacity.Answered} dataKey="Answered" stackId="a" fill="#5D985D" />
						<Bar strokeOpacity={opacity.Accepted} dataKey="Accepted" stackId="a" fill="#E5A52D" />
					</BarChart>
				</ResponsiveContainer>
			</Spin>
		</>
	)
}